import { useEffect, useState } from "react";

/**
 * Creates a debounced function that delays invoking a simple callback function until after wait milliseconds have elapsed
 * since the last time the debounced function was invoked.
 * @param callback The function to debounce.
 * @param debounceTime  The number of milliseconds to delay the callback function
 * @returns The callback that debounces the function.
 */
const useDebounceValue = <T>(value: T, delay = 500): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const id = setInterval(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(id);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounceValue;
